import { getTriviaFormatLabel, resolveCustomCategory } from "../../../utils/triviaArcade";

export const MIXED_FORMAT = "mix";

export const PACK_FORMATS = [
  { value: MIXED_FORMAT, label: "Preset mix" },
  { value: "higher_lower", label: getTriviaFormatLabel("higher_lower") },
  { value: "multiple_choice", label: getTriviaFormatLabel("multiple_choice") },
  { value: "true_false", label: getTriviaFormatLabel("true_false") },
];

export const PACK_DIFFICULTIES = [
  { value: "easy", label: "Easy" },
  { value: "medium", label: "Medium" },
  { value: "hard", label: "Hard" },
];

export const PACK_COUNTS = [5, 10, 15, 20];

export const DEFAULT_PACK_OPTIONS = {
  category: "career_stats",
  format: MIXED_FORMAT,
  difficulty: "medium",
  count: 5,
  seed: "",
};

// The engine only has canned mixes for daily/10 and quick/5; everything else
// falls back to the preset's customCycle.
const MIXED_MODE_BY_COUNT = { 5: "quick", 10: "daily" };

export function resolvePackMode({ format, count }) {
  if (format !== MIXED_FORMAT) return "custom";
  return MIXED_MODE_BY_COUNT[count] || "custom";
}

export function buildPreviewRequest({ sport, options, preset }) {
  const { category, format, difficulty, count, seed } = options;
  const trimmedSeed = typeof seed === "string" ? seed.trim() : seed;

  return {
    sport,
    mode: resolvePackMode(options),
    difficulty,
    count,
    category: resolveCustomCategory(sport, category),
    ...(format === MIXED_FORMAT ? {} : { format }),
    ...(trimmedSeed ? { seed: trimmedSeed } : {}),
    preset,
  };
}

export function engineErrorMessage(error, fallback = null) {
  if (!error) return null;
  if (typeof error === "string") return error;
  return (
    error.data?.error ||
    error.data?.message ||
    (typeof error.error === "string" ? error.error : null) ||
    error.message ||
    fallback
  );
}
